module.exports = __webpack_public_path__ + "static/img/twjd-sdh2.fac5616.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdh2.png
// module id = 847
// module chunks = 0